export default __webpack_public_path__ + "static/media/square-purple-1.ed3a5e38.png";